// extracted by mini-css-extract-plugin
export default {"footer":"App_footer__e+Tfn"};